var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-wrapper"},[_c('div',{staticClass:"container"},[_c('vue-navigation-bar',{attrs:{"options":_vm.navbarOptions},on:{"vnb-item-clicked":_vm.vnbItemClicked},scopedSlots:_vm._u([{key:"custom-section",fn:function(){return [_c('div',{staticClass:"custom-section-content d-flex flex-column"})]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }